// src/pages/Shop.js
import { LogoMark } from '../components/Icon';
import { PageShell, PageTitle } from '../components/PageShell';
import { C, GRADIENTS, FONTS } from '../styles/theme';

export function Shop() {
  return (
    <PageShell>
      <PageTitle>Notre boutique</PageTitle>

      <div style={{ background: GRADIENTS.primary, borderRadius: 24, overflow: 'hidden', marginBottom: 20 }}>
        <div style={{ height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ display: 'flex', gap: 10, transform: 'rotate(-8deg)' }}>
            {['#c0392b','#1a237e','#2c2c2c','#f9a825','#6a1b9a'].map((c, i) => (
              <div key={i} style={{ width: 10, height: 72, background: c, borderRadius: 5, transform: `rotate(${i*3-6}deg)` }}/>
            ))}
          </div>
        </div>
        <div style={{ padding: '16px 24px 24px' }}>
          <div style={{ fontFamily: FONTS.display, fontSize: 22, color: '#fff', fontStyle: 'italic', marginBottom: 4 }}>Accessoire artisanal</div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.8)' }}>Fait avec soin, pour vous deux ✦</div>
        </div>
      </div>

      <a href="https://saxeclub.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'block' }}>
        <div style={{ background: C.text, borderRadius: 20, padding: '20px 24px', display: 'flex', alignItems: 'center', gap: 16, boxShadow: '0 8px 32px rgba(61,46,36,0.2)' }}>
          <div style={{ width: 48, height: 48, borderRadius: '50%', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <LogoMark size={36}/>
          </div>
          <div>
            <div style={{ fontFamily: FONTS.display, fontSize: 20, color: C.white, fontStyle: 'italic' }}>Visiter notre site</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', marginTop: 2 }}>saxeclub.com</div>
          </div>
          <div style={{ marginLeft: 'auto', color: 'rgba(255,255,255,0.35)', fontSize: 20 }}>→</div>
        </div>
      </a>

      <div style={{ marginTop: 24, padding: '20px', background: C.bgMuted, borderRadius: 20 }}>
        <div style={{ fontFamily: FONTS.display, fontSize: 17, color: C.text, fontStyle: 'italic', marginBottom: 10 }}>Pourquoi artisanal ?</div>
        <p style={{ fontSize: 14, color: C.textMid, lineHeight: 1.7 }}>
          Chaque accessoire est conçu à la main avec des matériaux choisis. Parce que ce qui compte, c'est la qualité du moment que vous partagez.
        </p>
      </div>
    </PageShell>
  );
}
